import EventDispatcher from '@/base/event/event-dispatcher';
import { throttle } from '@/lib/tools';
const THRESHOLD = 0.15;

/**
 * 利用 IntersectionObserver 监听对象是否处理可视区，浏览器要求：Chrome 51+
 *
 */ 
function createObserver() {
    let io = new IntersectionObserver(
        entries => {
          entries.forEach((en, index) => {
            let target = en.target;
            if(en.isIntersecting && en.intersectionRect.height && en.intersectionRatio > THRESHOLD) {
                // console.log(`${THRESHOLD} >>> target index = `, target.dataIndex)
                // console.log('Time: ' + en.time);
                // console.log('Html: ' + target.outerHTML);
                // console.log('IntersectionRatio: ' + en.intersectionRatio);
                // console.log('rootBounds: ' + en.rootBounds);
                // console.log('boundingClientRect: ', en.boundingClientRect);
                // console.log('intersectionRect: ', en.intersectionRect);
                console.log('data-index = ', target.attributes['data-index'].value)
                this.dispatchEvent('pageChange', { page: Number(target.attributes['data-index'].value) });
            }
          });
        },
        Object.assign({ threshold: THRESHOLD }, this.options)
    );
    return io;
}


// 后面根据data-index取页码
function scrollHandler(evt) {
    if(!this.$parent) {
        return;
    }
    let el = this.$parent;
    const offset = el.getBoundingClientRect();
    const offsetTop = offset.top;
    const offsetBottom = offset.bottom;
    // 进入可视区域
    if (offsetTop <= window.innerHeight && offsetBottom >= 0) {
        this.calcPageThrottle(Math.abs(offsetTop));
    } else {
        console.log('window scroll >>> 移出可视区域');
    }
}

class ObserverPage extends EventDispatcher {
    /**
     * @param { dom } parent 父级结点，在浏览器不支持 IntersectionObserver 的时候使用
     * @param { Object } options 页面监听相关参数
     *     root: 属性指定目标元素所在的容器节点（即根元素）。注意，容器元素必须是目标元素的祖先节点。
     *     threshold: 属性决定了什么时候触发回调函数，比如，[0, 0.25, 0.5, 0.75, 1]就表示当目标元素 0%、25%、50%、75%、100% 可见时，会触发回调函数。
     */
    constructor(parent, options) {
        super();
        this.options = options || {
            callback: function () {}
        };
        this.$parent = parent;
        this.pageTimer = null;

        if(window.IntersectionObserver) {
            this.io = createObserver.call(this, options);
        }
        this.bindEvents();

    }

    bindEvents() {
        if(!this.io) {
            let scrollThrottle = throttle(scrollHandler, 500, this, true);
            this.calcPageThrottle = throttle(offsetTop => {
                console.log('window scroll >>> 进入可视区域');
                this.dispatchEvent('pageScroll', {
                    offsetTop
                });
            }, 300, this, true);
            window.addEventListener('scroll', scrollThrottle);
        }
    }
  
    observe(el) {
        if(this.io) {
            this.io.observe(el);
        }
    }

}

export default ObserverPage;